export default __webpack_public_path__ + "static/media/boneco1.332c7aa1.svg";